export { default } from './IconBadge'
